import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { replace } from 'connected-react-router';
import { OTHER_DISEASE } from 'utils/constants/disease';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';
import { getUserCondition } from 'modules/user/utils';

export const useOtherCancerRedirect = (to = ROUTE_PATH[ROUTE_NAME.FEED]) => {
  const dispatch = useDispatch();
  const { data: profile } = useSelector(
    (state) => state?.profile,
  );
  const condition = getUserCondition(profile);

  useEffect(() => {
    if (condition === OTHER_DISEASE) {
      dispatch(replace(to));
    }
  }, [condition, dispatch, to]);
};
